import * as React from "react";
import Typography from "@mui/material/Typography";
import { DARK_COLOR } from "./constants";

interface TitleProps {
  children?: React.ReactNode;
}

export default function Title(props: TitleProps) {
  return (
    <Typography component="h2" variant="h6" color={DARK_COLOR} gutterBottom>
      {props.children}
    </Typography>
  );
}
